import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2026 Sunday Best. Made with ❤️ for moments that matter.</p>
    </footer>
  );
}
